
exec();

async function exec() {

let params = new URLSearchParams(window.location.search)

let idParam = false;
if(params && params.has('id')) {
  idParam = params.get('id');
  Cookies.set('lastId', idParam)
} else if (idParam == false && Cookies.get('lastId')){
  idParam = Cookies.get('lastId');
}

console.log(Cookies.get('lastId'))


if(idParam) {

  let operatorApiKey = '0RhXUvAfcSSiRUFGSVACXC7sAvoak4DSwXebsDGHVJNKxAJnIx7sxwgP54Uve4Whxvx1aiuLIvi7QTkV';

  const operator = new evrythng.Operator(operatorApiKey);

  const thngId = idParam

  if($('.cProd__buttons .resell').length) {
    $('.cProd__buttons-holder a').eq(0).attr('href', '/pages/resell-submission?id='+thngId)
  }

  try {
  
    const thngResponse = await operator.thng(thngId).read();

    if (!thngResponse) {
      // NOT res.status >= 200 && res.status < 300
      console.log( { statusCode: thngResponse.status, body: thngResponse.statusText } );
    }
    const data = await thngResponse.json();

    const productResponse = await operator.product(data.product).read();

    //get data from Shopify

    if(productResponse.identifiers.sku) {

      $.ajax({
        url: 'https://at-routes-for-map-d0602397f1c7.herokuapp.com/product-info?sku='+productResponse.identifiers.sku,
        method: 'GET',
        success: function(info){

          const data = JSON.parse(info.body)

          if(data.image) {
            $('.cProd__image-holder img').attr('src', data.image)
          }

          if(data.description) {
            $('.cProd__info-descr').html(data.description)
          }

          if(data.title) {
            $('.cProd__info-title').html(data.title)
          }

          if(data.url && $('.cProd__buttons .repurchase')) {
            $('.cProd__buttons .repurchase').attr('href', data.url)
          }

          $('.loading-overlay__spinner').addClass('hidden')

          $('.cProd').show();

        }
      });

     }

     // 3.2 get purchaseOrder IDs
     const poNumber = await thngResponse.customFields.purchaseOrder

     // 3.3 get Purchase Order Details
     const purchaseOrderResponse = await operator.purchaseOrder(poNumber).read()

     // 3.3 filter out matching purchase orders
     const matchingPurchaseOrders = purchaseOrderResponse.lines.filter(
       (line) => line.product === `gs1:01:${productResponse.identifiers['gs1:01']}`,
     )

     // 3.3 filter out matching parties to "ship-from"
     const matchingShipToParties = purchaseOrderResponse.parties.filter(
       (party) => party.type === 'ship-from',
     )

     if (!matchingPurchaseOrders[0]?.customFields?.primaryArticle) {
       setIdNotFound(true)
       return
     }

     // 3.4 get product from primary article ids
     const primaryArticleNumberProduct = await operator
       .product(`articleNumber:${matchingPurchaseOrders[0].customFields.primaryArticle}`)
       .read()

      if(primaryArticleNumberProduct.customFields.copySection4A) {
        renderArticles(primaryArticleNumberProduct.customFields.copySection4A)
      }

      if(primaryArticleNumberProduct.customFields.copySection4B) {
        renderArticles(primaryArticleNumberProduct.customFields.copySection4B)
      } 

      if(primaryArticleNumberProduct.customFields.copySection4C) {
        renderArticles(primaryArticleNumberProduct.customFields.copySection4C)
      } 

      if(primaryArticleNumberProduct.customFields.copySection4D) {
        renderArticles(primaryArticleNumberProduct.customFields.copySection4D)
      }
      
      if(primaryArticleNumberProduct.customFields.copySection4E) {
        renderArticles(primaryArticleNumberProduct.customFields.copySection4E)
      } 

     const secondaryArticleStringIds =
       matchingPurchaseOrders[0].customFields.secondaryArticles || []
     let secondaryArticlesIdsArray = []
     if (secondaryArticleStringIds.length) {
       const hasSemiColon = secondaryArticleStringIds.includes(';') // adding this cause some secondary articles are split with ; and others ,
       secondaryArticlesIdsArray = hasSemiColon
         ? secondaryArticleStringIds?.split(';')
         : secondaryArticleStringIds?.split(',')
     }

     // 3.4 get product from secondary article ids, split into array from comma-seperated-strings, loop through those ids to retrieve product data from secondary articles
     let secondaryArticleLocations = []

     if (secondaryArticlesIdsArray.length) {
       const secondaryArticleNumberProducts = await Promise.all(
         secondaryArticlesIdsArray.map(async (secondaryArticleId) => {
           const secondaryArticle = await operator
             .product(`articleNumber:${secondaryArticleId}`)
             .read()
           return secondaryArticle
         }),
       )


       secondaryArticleLocations = secondaryArticleNumberProducts.map((secondaryArticle) => {
         const keys = Object.keys(secondaryArticle.customFields)
         const locationKeys = keys.filter((key) => key.includes('Location'))
         return Object.fromEntries(
           locationKeys
             .filter((key) => key in secondaryArticle.customFields)
             .map((key) => [key, secondaryArticle.customFields[key]]),
         )
       })
     }

     // 3.5 get facory details
     const factoryIdFilter = `identifiers.factory=${matchingShipToParties[0].id.replace(
       'factory:',
       '',
     )}`
     const factoryData = await operator.place().setFilter(factoryIdFilter).read()

     // Now build all data
     const finalData = {
       product: productResponse,
       primaryArticleNumberProduct,
       factoryData: factoryData[0],
       secondaryArticleLocations,
     }

     console.log(finalData);

     if(factoryData[0].customFields.copySection4F) {
      renderArticles(factoryData[0].customFields.copySection4F)
     } 

     if(factoryData[0].customFields.copySection4G) {
      renderArticles(factoryData[0].customFields.copySection4G)
     } 

     if(factoryData[0].customFields.whoMade) {
      $('#who-made').html('<p>'+factoryData[0].customFields.whoMade+'</p>' + '<p>'+factoryData[0].customFields.wimStat1+ '</p>');
     }

     if(primaryArticleNumberProduct.customFields.welfareAnimal) {
      $('#animal').html('<p>'+primaryArticleNumberProduct.customFields.welfareAnimal+'</p>' + '<p>'+primaryArticleNumberProduct.customFields.wimStat2+ '</p>');
     }

     if(primaryArticleNumberProduct.customFields.welfareEnvironmental) {
      $('#environm').html('<p>'+primaryArticleNumberProduct.customFields.welfareEnvironmental+'</p>' + '<p>'+primaryArticleNumberProduct.customFields.wimStat3+ '</p>');
     }


      const createCoords = async (address, key) => {

        const geocoder = new google.maps.Geocoder();  


        try {


          const coords = await geocoder.geocode({address:address});

          const lat = coords?.results[0]?.geometry?.location.lat() || null
          const lng = coords?.results[0]?.geometry?.location.lng() || null

          const markerData = {
            name: address,
            color: markerInfo[key].color,
            label: markerInfo[key].label,
            position: {
              lat,
              lng,
            },
          }
          return markerData
        } catch (err) {
          return false
        }
      }


      const getStateLocation = async (filteredLocations, secondaryArticleLocations) => {
        const combinedLocations = Object.entries(filteredLocations)
          .filter((l) => !!l[1])
          .map((location) => createCoords(location[1], location[0]))

        const locationsData = await Promise.allSettled(combinedLocations)
        const locations = locationsData.filter((l) => !!l).filter((l) => !!l.value)
        //setMarkers(locations)
        console.log(locations)

        return locations;
      }

      let customFields = {
        ...productResponse.customFields,
        ...primaryArticleNumberProduct.customFields,
        ...factoryData[0].customFields,
      }
       
      let keys = [];

      for(let customField of Object.entries(customFields)) {
        if(customField[0].includes('Location') && !customField[1].includes('N/A')) {
          let key = customField[0];
          keys.push(key);
        }

      }

      console.log(keys)
  
      const customFieldLocations =  Object.fromEntries(
        keys.filter((key) => key in customFields).map((key) => [key, customFields[key]]),
      )
  
      let factoryAddress = factoryData[0].address;


      //it seems it show Factory when we have less than 3 points but I wasn't able to find it in code
     // if(customFieldLocations < 3) {
        customFieldLocations.factoryLocation = `${factoryAddress.city}, ${factoryAddress.country}`;
     // }
  
     

      console.log(customFieldLocations)

      let markers = await getStateLocation(customFieldLocations, null)

      var options = {
        zoom:2,
        center:{ lat: 37.09024,
                lng: -95.712891},
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,        
        styles
      }

      var map = new google.maps.Map(document.getElementById('googleMap'),options);



      for(let marker of markers) {
        const markerImage = {
          // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
          fillOpacity: 1,
          path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
          fillColor: marker.value.color,
          strokeWeight: 1,
          strokeColor: 'black',
          scale: 0.1,
        }

        new google.maps.Marker({
          position:{
              lat: marker.value.position.lat,
              lng: marker.value.position.lng,
          },
					map: map,
					icon: markerImage
				});

        let markerInfo = `<svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="6"
                  cy="6.70312"
                  r="5.75"
                  fill="white"
                  stroke="black"
                  strokeWidth="0.5"
                />
                <circle cx="6" cy="6.70312" r="4" fill=`+marker.value.color+` />
              </svg> <span>`+marker.value.label+`</span>`

        $('.cProd__map-markers').append('<div class="cProd__map-markers-item">'+markerInfo+'</div>')

      }

      
      
      const bounds = new google.maps.LatLngBounds()
     
      markers.map((item) => {
        bounds.extend(item.value.position)
        return item.id
      })

      map.fitBounds(bounds)


    
  } catch (err) {
  
    console.log('error'); // output to netlify function log
    console.log(err); // output to netlify function log
  
  }

} else {
  
  $('.loading-overlay__spinner').addClass('hidden')

  $('.cProd').show();
}

}

function renderArticles(data) {

let num = parseInt($('.cProd__proven-item-value').length) + 1;

  $('#provenance > div ').append(`
            <div class="cProd__proven-item">
              <div class="cProd__proven-item-number">`+num+`</div>
              <div class="cProd__proven-item-value">`+data+`</div>
            </div>
          `);
}

$(document).ready(function(){
  const anchorSelector = 'a[href^="#"]';

  $(anchorSelector).on('click', function (e) {
      e.preventDefault();

      const destination = $(this.hash);
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position-desktop');
      const scrollPosition = destination.offset().top - parseFloat(headerHeight);

      $('html, body').animate({
          scrollTop: scrollPosition
      }, 500);
  });
});